import control from './interactWithChannelControl.js';
import entry from './interactWithChannelEntry';

export default { control, entry };
